module.exports = __webpack_public_path__ + "static/img/rob.ddeca3ad.png";